export default class DataBinder {
	constructor(context) {
		this.defaultContext = context;
	}
	populate(pageId, context, page) {
		if (!page) page = document.getElementById(pageId);
		if (!page && pageId) { console.warn("Page Id not found"); return; }
		if (!page) { page = document; }
		if (!context) context = this.defaultContext;

		//template need to be first to clear old data
		let elementsTemplate1 = page.querySelectorAll('[data-template]');
		for (let i = 0; i < elementsTemplate1.length; i++) {
			let element = elementsTemplate1[i];
			let templateId = element.dataset.template;
			let template = document.querySelector("#" + templateId);
			if (template) {
				//clear children
				while (element.firstChild) {
					element.removeChild(element.firstChild);
				}
			}
		}

		let elementsSrc = page.querySelectorAll('[data-src]:not(template)');
		for (let i = 0; i < elementsSrc.length; i++) {
			let element = elementsSrc[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}

			let key = element.dataset.src;
			if (!this.isTemplate(key)) {
				let value = this.evalInContext(model, key);
				if (typeof value !== 'undefined' && value !== null) { //don't overwrite with null
					element.src = value;
				}
			} else {
				//try to phase template
				let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
				let template = key;
				let keys = []
				var match;
				//check if the values exist
				let valuesExisits = false;
				while (match = regex.exec(template)) {
					keys.push(match);
					let keyValue = model[match[1]];
					if (typeof keyValue !== "undefined")
						valuesExisits = true;
				}
				if (keys.length === 0) valuesExisits = false;
				//resolve template
				if (valuesExisits) {
					let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
						return model[p1] || null;;
					});
					element.src = templateResolved;
				}
			}
		}
		let elementsStyle = page.querySelectorAll('[data-style]:not(template)');
		for (let i = 0; i < elementsStyle.length; i++) {
			let element = elementsStyle[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}

			let key = element.dataset.style;
			if (!this.isTemplate(key)) {
				let value = this.evalInContext(model, key);
				if (typeof value !== 'undefined') {
					element.style = value;
				}
			} else {
				//try to phase template
				let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
				let template = key;
				let keys = []
				var match;
				//check if the values exist
				let valuesExisits = false;
				while (match = regex.exec(template)) {
					keys.push(match);
					let keyValue = model[match[1]];
					if (typeof keyValue !== "undefined")
						valuesExisits = true;
				}
				if (keys.length === 0) valuesExisits = false;
				//resolve template
				if (valuesExisits) {
					let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
						return model[p1] || null;
					});
					element.style = templateResolved;
				}
			}
		}
		let elementsOnClick = page.querySelectorAll('[data-onclick]:not(template)');
		for (let i = 0; i < elementsOnClick.length; i++) {
			let element = elementsOnClick[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}

			let key = element.dataset.onclick;
			let value = model[key] || key; // does the model have function with this name
			if (typeof value === 'function') {
				element.onclick = value;
			} else if (!this.isTemplate(value)) {
				// For onclick, assign the script string directly, don't execute it
				element.setAttribute('onclick', value);
			} else {
				//try to phase template
				let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
				let template = value;
				let keys = []
				var match;
				//check if the values exist
				let valuesExisits = false;
				while (match = regex.exec(template)) {
					keys.push(match);
					let keyValue = model[match[1]];
					if (typeof keyValue !== "undefined")
						valuesExisits = true;
				}
				if (keys.length === 0) valuesExisits = false;
				//resolve template
				if (valuesExisits) {
					let templateResolved = value.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
						if (model[p1]) return model[p1];
						if (model[p1] === "") return "";
						return null;
					});
					element.setAttribute('onclick', templateResolved);
				}
			}
		}
		let elementsValue = page.querySelectorAll('[data-value]:not(template)');
		for (let i = 0; i < elementsValue.length; i++) {
			let element = elementsValue[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.value;

			let value = this.evalInContext(model, key);
			if (typeof value !== 'undefined') {
				element.value = value;
			}
			else {
				element.value = null;
			}
		}
		let elementsMax = page.querySelectorAll('[data-max]:not(template)');
		for (let i = 0; i < elementsMax.length; i++) {
			let element = elementsMax[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.max;

			let value = this.evalInContext(model, key);
			if (typeof value !== 'undefined') {
				element.max = value;
			}
			else {
				element.max = null;
			}
		}
		let elementsInnerText = page.querySelectorAll('[data-inner-text]:not(template)');
		for (let i = 0; i < elementsInnerText.length; i++) {
			let element = elementsInnerText[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.innerText;
			if (!this.isTemplate(key)) {
				let value = this.evalInContext(model, key);
				if (typeof value !== 'undefined') {
					element.innerText = value;
				}
			}
		}
		let elementsInnerHTML = page.querySelectorAll('[data-inner-html]:not(template)');
		for (let i = 0; i < elementsInnerHTML.length; i++) {
			let element = elementsInnerHTML[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.innerHtml;
			let value = this.evalInContext(model, key);
			if (typeof value !== 'undefined') {
				element.innerHTML = value;
			}
		}
		let elementsShow = page.querySelectorAll('[data-show]:not(template)');
		for (let i = 0; i < elementsShow.length; i++) {
			let element = elementsShow[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.show;
			let value = this.evalInContext(model, key);
			if (value)
				element.style.display = '';
			else
				element.style.display = 'none';
		}
		let elementsDisabled = page.querySelectorAll('[data-disabled]:not(template)');
		for (let i = 0; i < elementsDisabled.length; i++) {
			let element = elementsDisabled[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.disabled;
			let value = this.evalInContext(model, key);
			if (value)
				element.disabled = true;
			else
				element.disabled = false;
		}

		let elementsHidden = page.querySelectorAll('[data-hidden]:not(template)');
		for (let i = 0; i < elementsHidden.length; i++) {
			let element = elementsHidden[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.hidden;
			let value = this.evalInContext(model, key);
			if (value)
				element.style.display = 'none';
			else if (element.style.display === 'none')
				element.style.display = '';

		}
		let elementsChecked = page.querySelectorAll('[data-checked]:not(template)');
		for (let i = 0; i < elementsChecked.length; i++) {
			let element = elementsChecked[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.checked;
			let value = this.evalInContext(model, key); //Never use eval()!,
			if (typeof value === "boolean" && value === true) {
				element.checked = true;
			}
			else if (value === element.value) {
				element.checked = true;
			} else {
				element.checked = false;
			}
		}
		let elementsSelected = page.querySelectorAll('[data-selected]:not(template)');
		for (let i = 0; i < elementsSelected.length; i++) {
			let element = elementsSelected[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let key = element.dataset.selected;
			let value = this.evalInContext(model, key); //Never use eval()!,
			if (typeof value === "boolean" && value === true) {
				element.selected = true;
			}
			else if (value === element.value) {
				element.selected = true;
			} else {
				element.selected = false;
			}
		}

		for (const element of page.querySelectorAll('[data-class]:not(template)')) {
			let model = context;
			if (element.dataset.model && model[element.dataset.model]) {
				model = model[element.dataset.model];
			}
			let key = element.dataset.class;
			//try to phase template
			let regex = /\{([^}]+)\}/g; //key.match(/\{([^}]+)\}/g);
			let template = key;
			let keys = []
			var match;
			//check if the values exist
			let valuesExisits = false;
			while (match = regex.exec(template)) {
				keys.push(match);
				let keyValue = model[match[1]];
				if (typeof keyValue !== "undefined")
					valuesExisits = true;
			}
			if (keys.length === 0) valuesExisits = false;
			//resolve template
			if (valuesExisits) {
				let templateResolved = key.replace(/\{([^}]+)\}/g, function (match, p1, offset, string) {
					return model[p1] || null;
				});
				element.classList.add(templateResolved);
			}
		}

		//template need to be first to clear old data
		let elementsTemplate = page.querySelectorAll('[data-template]');
		for (let i = 0; i < elementsTemplate.length; i++) {
			let element = elementsTemplate[i];
			let model = context;
			if (element.dataset.model) {
				if (model[element.dataset.model]) {
					model = model[element.dataset.model];
				}
			}
			let templateId = element.dataset.template;
			let template = document.querySelector("#" + templateId);
			if (template) {
				//clear children
				while (element.firstChild) {
					element.removeChild(element.firstChild);
				}
				for (let j = 0; j < model.length; j++) {
					let itemModel = model[j];
					//copy template
					let clone = document.importNode(template.content, true);
					//and populate it
					this.populate(null, itemModel, clone);
					//add it
					element.appendChild(clone);
				}
			}
		}

	}

	evalInContext(context, scr) {
		if (!context) return;
		if (!scr) return;
		if (context.hasOwnProperty(scr)) return context[scr];
		try {
			// execute script in private context
			let value = (new Function("with(this) { return " + scr + "}")).call(context);
			return value;

		} catch (ex) {
			console.warn(ex, context, scr);
		}
	}
	createAndShow(templateId, model, destinationId) {
		//copy template and populate
		let element = this.create(templateId, model);
		//add to destination
		this.show(element, destinationId);
	}
	show(element, destinationId) {
		if (!element) return;
		//find destination
		let destination = document.body;
		if (destinationId)
			destination = document.getElementById(destinationId);
		//add to destination
		if (!destination) return;
		destination.appendChild(element);
		return element;
	}
	create(templateId, model) {
		//copy template and populate
		var template = document.getElementById(templateId);
		if (!template) return;
		let element = document.importNode(template.content, true);
		if (!element) return;
		this.populate("", model, element);
		return element;
	}
	isTemplate(value) {
		let regex = "\{.*\}";
		let isTemplate = value.match(regex);
		return isTemplate;
	}

}

